import Fingerprint2 from 'fingerprintjs2'

const waitUntilIdle = window.requestIdleCallback || (fn => setTimeout(fn, 500))
const FINGERPRINT_KEY = 'device_fingerprint'

const generateDeviceFingerprint = () =>
    new Promise(resolve => {
        if (FINGERPRINT_KEY in localStorage) return resolve(localStorage.getItem(FINGERPRINT_KEY))

        waitUntilIdle(() => {
            Fingerprint2.get(components => {
                const values = components.map(component => component.value).join('')
                const hash = Fingerprint2.x64hash128(values, 31)
                localStorage.setItem(FINGERPRINT_KEY, hash)
                resolve(hash)
            })
        })
    })

export { generateDeviceFingerprint }
